<div fxFlex="column" class="grade-dialog">

    <div class="dialog-header">
        {{ title }}
    </div>

    <div class="grade-container" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="20" class="form-key">
                Grade :
            </div>
            <div fxFlex="75">
                <mat-form-field class="full-width">
                    <input type="string" matInput [(ngModel)]="grade">
                  </mat-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="20" class="form-key">
                Feedback Text :
            </div>
            <div fxFlex="75">
                <mat-form-field class="full-width">
                    <textarea matInput multiline rows="2" maxRows="5" [(ngModel)]="feedbackText"></textarea>
                    <!-- <textarea matInput [matTextareaAutosize]="true" [matAutosizeMaxRows]="5" [(ngModel)]="feedbackText"></textarea> -->
                </mat-form-field>
            </div>
        </div>

        <div class="button-container" fxLayout="row" fxLayoutAlign="space-around center">
            <div>
                <button
                    class="cancel-button button"
                    mat-button
                    type="button"
                    (click)="onCancel()"
                >
                    Cancel
                </button>
            </div>
            <div>
                <button
                [disabled]="grade === null"
                class="submit-button button"
                mat-button
                type="button"
                (click)="onSubmit()"
            >
                Submit
            </button>
            </div>
        </div>
    </div>
</div>
